const config = {
	isProduction: import.meta.env.PROD,
	tutorAImessageMaxLenght: 50000,
	apiUrl: import.meta.env.VITE_APP_API_URL,
	assetsPath: import.meta.env.VITE_BASE_URL,
};

export default config;
